import AppButton from './AppButton';
import Brand from './Brand';
import './SiteHeader.css';

function SiteHeader() {
  return (
    <header className="site-header">
      <Brand />
      <nav aria-label="Primary navigation">
        <a href="/#how-it-works">How it works</a>
        <a href="/#features">Features</a>
        <a href="/#download">Download</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </nav>
      <AppButton className="header-download" />
    </header>
  );
}

export default SiteHeader;
